export const BLOG_LOCALE = "en";
export const BLOG_ROOT_PATH = "/blog";

export function isEnglishOnlyBlogPath(path: string) {
  return path === BLOG_ROOT_PATH || path.startsWith(`${BLOG_ROOT_PATH}/`);
}
